// src/pages/Profile.jsx
import React, { useState } from "react";

export default function Profile() {
  const [profile, setProfile] = useState({
    name: "Sourav Kumar",
    email: "sourav@example.com",
    phone: "+91 98765 43210",
    role: "HR Manager",
    location: "Bengaluru, India",
  });

  return (
    <div className="p-6 max-w-3xl">
      <h1 className="text-2xl font-semibold mb-4">My Profile</h1>

      <div className="bg-white p-6 rounded-xl shadow border">
        <div className="flex items-center gap-6">
          <div className="w-24 h-24 rounded-full bg-gray-200 grid place-items-center text-2xl font-bold">
            S
          </div>

          <div className="flex-1">
            <h2 className="text-xl font-semibold">{profile.name}</h2>
            <p className="text-gray-500">{profile.role} • {profile.location}</p>

            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <p className="font-medium">{profile.email}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Phone</p>
                <p className="font-medium">{profile.phone}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-x-3">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-xl">Edit Profile</button>
          <button className="px-4 py-2 border rounded-xl">Change Password</button>
        </div>
      </div>
    </div>
  );
}
